import { createApp } from 'vue'
import App from './layout.vue'
import './style.css'
import { createRouter, createWebHashHistory } from 'vue-router'
import routes from './router'
import './typings/router' // 导入路由类型定义
import ErrorHandler from './plugins/error-handler'
import Sentry from './utils/sentry.ts'

const router = createRouter({
  scrollBehavior() {
    return { top: 0 }
  },
  history: createWebHashHistory(),
  routes
})

router.beforeEach(async (to, _, next) => {
  if (to.meta.auth) {
    next('/login')
  } else {
    next()
  }
})

const app = createApp(App)

// 配置Sentry
Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration()
  ],
  // 性能监控
  tracesSampleRate: 1.0,
  // 会话重放
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // 过滤敏感信息
  beforeSend(event) {
    // 过滤掉开发环境的错误
    // if (import.meta.env.DEV) {
    //   return null
    // }
    return event
  }
})

window.hxe?.setNavigationBar?.({
  show: false
})

app.use(router).use(ErrorHandler).mount('#app')
